var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 265,
    viewBox: "0 0 280 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1116_3276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.711 89.2444C188.642 63.5386 207.948 10.2613 189.726 2.79903C166.949 -6.52883 137.447 20.3701 113.368 84.5805",
    stroke: "#8952E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3889 121.828C13.9464 121.828 15.2089 120.566 15.2089 119.008C15.2089 117.451 13.9464 116.188 12.3889 116.188C10.8314 116.188 9.56885 117.451 9.56885 119.008C9.56885 120.566 10.8314 121.828 12.3889 121.828Z",
    stroke: "#E0526C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9146 119.295C23.6027 118.71 32.5279 119.402 33.5828 123.802C34.6378 128.202 30.6094 129.811 28.4635 130.066C20.2933 131.365 9.45996 130.754 9.45996 123.802",
    stroke: "#E0526C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8598 125.95C16.2192 125.95 16.5105 125.658 16.5105 125.299C16.5105 124.94 16.2192 124.648 15.8598 124.648C15.5003 124.648 15.209 124.94 15.209 125.299C15.209 125.658 15.5003 125.95 15.8598 125.95Z",
    stroke: "#E0526C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1503 125.299C22.1503 125.615 21.8558 125.95 21.3911 125.95C20.9264 125.95 20.6318 125.615 20.6318 125.299C20.6318 124.983 20.9264 124.648 21.3911 124.648C21.8558 124.648 22.1503 124.983 22.1503 125.299Z",
    stroke: "#E0526C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9228 125.95C27.2822 125.95 27.5735 125.658 27.5735 125.299C27.5735 124.94 27.2822 124.648 26.9228 124.648C26.5633 124.648 26.272 124.94 26.272 125.299C26.272 125.658 26.5633 125.95 26.9228 125.95Z",
    stroke: "#E0526C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.387 42.4331C227.825 42.4331 228.99 41.2676 228.99 39.8299C228.99 38.3923 227.825 37.2268 226.387 37.2268C224.95 37.2268 223.784 38.3923 223.784 39.8299C223.784 41.2676 224.95 42.4331 226.387 42.4331Z",
    stroke: "#125F64",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.501 37.5522C233.409 37.5522 238.859 37.5522 241.423 37.5522C243.5 37.5522 244.5 38.0117 244.5 41.2274C244.5 44.3518 244.474 48.399 244.5 50.0325C244.518 51.1809 243.946 52.4519 242.039 52.6356C240.131 52.8193 232.475 52.7122 228.886 52.6356C227.553 52.6356 225.194 51.8798 225.194 48.8073V45.3618",
    stroke: "#125F64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.183 42.9753L234.955 46.2292",
    stroke: "#125F64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.956 46.2292L243.633 38.2029",
    stroke: "#125F64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.155 44.2769L239.526 46.6631L241.897 49.0492",
    stroke: "#125F64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.448 49.0492L231.946 44.2769",
    stroke: "#125F64",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.464 205.124C244.743 205.846 244.122 206.469 243.694 206.897C242.577 208.015 241.405 207.363 240.959 206.897L233.838 200.037C232.787 199.059 231.898 198.094 227.925 194.304C227.518 193.896 226.873 192.856 227.549 191.954C228.225 191.052 232.023 186.315 233.838 184.059C234.388 183.262 235.585 182.313 237.11 183.732C238.425 184.954 242.93 189.183 246.778 192.398",
    stroke: "#FF5C00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.763 184.303C233.987 188.418 235.497 195.043 243.307 197.536",
    stroke: "#FF5C00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.57 197.854C253.212 196.944 250.463 195.885 249.424 197.854C248.354 199.886 249.172 201.597 249.869 201.933C250.758 202.361 252.064 202.585 253.444 200.119",
    stroke: "#FF5C00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.797 196.588C253.717 197.063 253.635 197.263 253.569 197.854C253.485 198.625 253.431 199.432 253.444 200.119C253.47 201.324 253.708 202.156 254.385 201.755C255.743 200.95 256.476 200.289 256.671 199.616C256.997 198.483 256.999 196.315 255.168 194.897C252.96 193.186 250.47 193.232 248.511 194.897C246.566 196.55 246.034 199.196 246.14 200.568C246.257 202.069 247.377 205.294 251.034 205.344C254.689 205.395 256.669 203.424 256.973 202.501",
    stroke: "#FF5C00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0888 170.76C60.309 167.75 57.7193 162.197 53.6011 164.074C49.4828 165.951 51.885 169.314 53.6011 170.76C54.7558 171.542 57.2384 172.379 57.9299 169.47C58.6215 166.561 55.7071 165.364 54.888 166.655C54.4561 167.163 53.9682 168.438 55.473 169.47",
    stroke: "#22B2BA",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.846 29.6201C79.6868 28.7911 80.0658 27.6015 79.8595 26.4389C79.5573 24.7353 81.3396 23.4247 82.8756 24.2211C83.9239 24.7645 85.1724 24.7574 86.2143 24.2019C87.7411 23.3881 89.5383 24.6782 89.2556 26.3851C89.0627 27.5499 89.4553 28.7352 90.3055 29.5545C91.5513 30.755 90.8797 32.863 89.169 33.1215C88.0016 33.298 86.9957 34.0377 86.4792 35.0995C85.7224 36.6553 83.5101 36.668 82.7355 35.1209C82.2069 34.0651 81.1926 33.337 80.0232 33.1739C78.3097 32.9349 77.614 30.8348 78.846 29.6201Z",
    stroke: "#E7C200",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.45 121.81V140.249",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.333 123.979V141.55",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86 203.827C123.276 204.397 112.544 206.503 110.193 210.784C109.488 212.068 108.67 215.193 111.04 217.419C113.409 219.646 117.74 219.06 119.609 218.49L130.505 214.101",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.334 171.521C181.78 171.796 143.999 190.087 126.178 199.198C124.661 209.237 131.065 216.446 134.457 218.795C152.22 213.638 188.678 203.186 192.403 202.636C196.128 202.086 199.819 199.427 201.198 198.166C210.856 186.89 203.728 177.309 198.957 173.928C195.56 171.521 192.628 171.447 190.334 171.521Z",
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.208 168.963C116.269 169.367 142.708 179.614 155.235 184.984L126.585 199.3C113.764 203.06 105.887 201.822 103.482 201.011C89.597 194.322 95.0371 177.818 100.554 171.705C104.109 168.679 108.036 168.818 110.208 168.963Z",
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.662 205.779C181.45 207.599 183.498 209.984 184.537 211.94C186.762 217.033 182.766 220.095 178.204 218.656C175.683 217.86 175.089 217.327 173.753 216.22C173.076 215.658 169.911 212.717 166.298 209.244",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.372 127.012L107.425 164.313C107.716 169.615 112.1 173.764 117.41 173.764H183.305C188.828 173.764 193.305 169.287 193.305 163.764V125.546C193.305 119.971 188.746 115.472 183.171 115.547L115.222 116.463C109.537 116.54 105.06 121.335 105.372 127.012Z",
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.403,
    y: 174.523,
    width: 85.903,
    height: 4.12161,
    rx: 2.06081,
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55 92.5247C168.106 92.4162 184.737 98.1647 191.353 116.278",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.955 92.4163C126.709 95.7786 118.466 103.154 111.958 117.363",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.657 109.572L205.887 102.522",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.888 111.524L211.636 106.752",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.755 114.778C207.876 115.212 210.421 115.624 211.636 113.802",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7969 108.252L89.2891 101.527",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.413 107.167L98.5088 97.0803",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1699 112.048L89.2891 110.204",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.692 128.445C199.705 134.735 204.261 142.219 195.692 156.301",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.658 93.0671C161.634 90.247 160.745 88.3493 159.877 87.9878C154.671 92.7602 146.775 90.9886 143.846 88.0963C142.805 89.0507 143.413 91.874 143.846 92.7417C149.486 98.9892 157.513 95.4894 160.658 93.0671Z",
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.556 110.421L137.993 109.75C140.449 105.981 145.228 104.476 149.4 106.158V106.158C153.147 107.669 157.439 106.621 160.068 103.554L163.478 99.575",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.606 132.439C101.979 136.272 100.049 145.563 105.342 152.071",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.614 48.7284C173.227 57.297 172.034 58.0563 168.564 61.8525C168.564 58.1007 167.919 51.8034 167.919 49.1813C156.554 49.1813 146.963 44.542 143.588 42.2224C143.709 50.0889 136.334 55.2325 136.334 55.2325C136.334 55.2325 137.392 58.4093 137.997 65.5195C138.48 71.2076 137.09 70.1083 136.334 68.8477C134.158 61.8283 130.592 63.7041 129.08 65.5195C110.536 35.3874 139.054 29.5652 144.495 30.1199C148.605 26.6102 154.338 23.8598 158.368 23.4564C172.902 22.0015 179.483 34.8347 175.614 48.7284Z",
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.589 74.2108C138.541 86.1299 151.645 94.7005 161.102 85.0453C170.558 75.39 168.666 57.7164 167.655 49.4692",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.866 64.781C127.673 67.7095 128.793 74.1988 136.589 74.1988",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.305 66.3894C132.132 67.0161 132.27 68.5008 134.202 69.4264",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.392 72.6803C169.937 71.6195 171.731 67.691 171.04 61.4001",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.075 79.8388C155.57 80.4896 155.412 78.6987 157.305 77.1272",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.522,
    cy: 64.6865,
    r: 1.62695,
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.205,
    cy: 64.9033,
    r: 1.62695,
    fill: "#0C111D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.663 61.1833C143.005 60.1753 144.482 58.3104 147.652 58.9152",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.848 59.231C158.604 58.5762 160.66 57.6595 162.837 59.231",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.599 63.7864C152.347 65.9283 152.175 70.272 153.509 70.5111",
    stroke: "#0C111D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.107 162.177C244.067 170.203 296.086 179.422 272.484 152.089C265.036 144.75 254.045 136.145 236.366 128.553",
    stroke: "#8952E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.453 106.099C264.458 94.5652 293.461 70.7394 265.434 67.7025C237.407 64.6655 211.817 75.1864 202.525 80.8265",
    stroke: "#8952E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8336 67.1004C60.1516 52.494 5.68122 30.0276 1.25591 57.0133C-3.1694 83.999 50.896 106.509 78.4819 114.39",
    stroke: "#8952E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.565 128.553C46.6267 148.402 -2.16248 175.853 24.8623 190.16C35.9254 196.017 64.2344 192.438 77.2501 187.123",
    stroke: "#8952E0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.269,
    cy: 258.492,
    rx: 53.6894,
    ry: 6.50781,
    fill: "#98A2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1116_3276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 265,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingBanner);
export default __webpack_public_path__ + "static/media/onboarding_banner.9802fa2ee981ed6e578b1fdce0bf6e15.svg";
export { ForwardRef as ReactComponent };